export default {
    setRequestError(state, payload){
      state.request_error = payload.message;
    },
    setInventory(state, payload) {
      state.inventory_of_search = payload;
    },
    setSelectedInventory(state, payload) {
      state.selected_inventory = payload;
    }
  };